import { AxiosError } from "axios";
import { isBaseError, toBaseError } from "../../../../common/utils/base_error";
import { axiosInstance } from "../../../../api/axiosInstance";
import {
  GetAllAuditorAuditoresRequest,
  GetAllAuditorAuditoresResponse,
} from "../daos/read/get_all_auditor_auditores";
import { IAuditorService } from "./auditor_service";
import { handleAxiosResponse } from "../../../../common/utils/axios_response";
import {
  CreateAuditorAuditoresRequest,
  CreateAuditorAuditoresResponse,
} from "../daos/create/create_auditor_auditores";
import {
  UpdateAuditorAuditoresRequest,
  UpdateAuditorAuditoresResponse,
} from "../daos/update/update_auditor_auditores";
import {
  DeleteAuditorAuditoresRequest,
  DeleteAuditorAuditoresResponse,
} from "../daos/delete/delete_auditor_auditores";
import {
  GetAllAuditorAuditoriaRequest,
  GetAllAuditorAuditoriaResponse,
} from "../daos/read/get_all_auditor_auditoria";
import {
  CreateAuditorAuditoriaRequest,
  CreateAuditorAuditoriaResponse,
} from "../daos/create/create_auditor_auditoria";
import {
  CreateAuditorProcessoAuditoriaRequest,
  CreateAuditorProcessoAuditoriaResponse,
} from "../daos/create/create_processo_auditor_auditoria";
import {
  GetAllAuditorProcessoAuditoriaRequest,
  GetAllAuditorProcessoAuditoriaResponse,
} from "../daos/read/get_all_auditor_processo_auditoria";
import {
  UpdateAuditorAuditoriaResponse,
  UpdateAuditoriaAuditoriaRequest,
} from "../daos/update/update_auditor_auditoria";
import {
  DeleteAuditorAuditoriaRequest,
  DeleteAuditorAuditoriaResponse,
} from "../daos/delete/delete_auditor_auditoria";
import {
  UpdateAuditoriaProcessoAuditoriaRequest,
  UpdateAuditorProcessoAuditoriaResponse,
} from "../daos/update/update_audito_processo_auditoria";
import {
  DeleteAuditorProcessoAuditoriaRequest,
  DeleteAuditorProcessoAuditoriaResponse,
} from "../daos/delete/delete_auditor_processo_auditoria";
import {
  AuditoriaCopiaRequest,
  AuditoriaCopiaResponse,
} from "../daos/create/auditoria_copia";
import { GetArquivoRequest } from "../daos/read/get_arquivo_auditores";
import { GetAllAuditoriaIndicadoresResponse } from "../daos/read/get_all_auditoria_indicadores";
import { AuditoriaIndicadores } from "../../domain/models/auditoria_indicadores_lista";
import {
  ProcessoAuditoriaCopiaRequest,
  ProcessoAuditoriaCopiaResponse,
} from "../daos/create/processo_auditoria_copia";
import { RequestObjectToFormData } from "../../../../common/utils/form_data_utils";
import { GetArquivoAuditoriaRequest } from "../daos/read/get_arquivo_auditoria";

//#region  Auditores
export class AuditorService implements IAuditorService {
  async getAllListagemAuditores(
    request: GetAllAuditorAuditoresRequest,
  ): Promise<GetAllAuditorAuditoresResponse> {
    try {
      const result = await axiosInstance({}).post(
        `auditor/auditores/listAuditores`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllAuditorAuditoresResponse>(result);

      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createAuditores(
    request: CreateAuditorAuditoresRequest,
  ): Promise<CreateAuditorAuditoresResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/auditor/auditores/create`,
        formData,
        options,
      );
      const response =
        handleAxiosResponse<CreateAuditorAuditoresResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async updateAuditor(
    request: UpdateAuditorAuditoresRequest,
  ): Promise<UpdateAuditorAuditoresResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/auditor/auditores/update`,
        formData,
        options,
      );
      const response =
        handleAxiosResponse<UpdateAuditorAuditoresResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async deleteAuditores(
    request: DeleteAuditorAuditoresRequest,
  ): Promise<DeleteAuditorAuditoresResponse> {
    try {
      const result = await axiosInstance({}).delete(
        "/auditor/auditores/delete",
        { data: request },
      );
      const response =
        handleAxiosResponse<DeleteAuditorAuditoresResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async getArquivo({
    idAuditores,
    imagePosition,
  }: GetArquivoRequest): Promise<Blob> {
    try {
      const result = await axiosInstance().get(
        `/auditor/auditores/${idAuditores}/image/${imagePosition}`,
        { responseType: "blob" },
      );
      const response = handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion

  //#region Auditoria
  async getAllListagemAuditoria(
    request: GetAllAuditorAuditoriaRequest,
  ): Promise<GetAllAuditorAuditoriaResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/auditor/auditorias/listAuditorias`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllAuditorAuditoriaResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getArquivoAuditoria({
    idAuditoria,
    imagePosition,
  }: GetArquivoAuditoriaRequest): Promise<Blob> {
    try {
      const result = await axiosInstance().get(
        `/auditor/auditoria/${idAuditoria}/arquivo/${imagePosition}`,
        { responseType: "blob" },
      );
      const response = handleAxiosResponse<Blob>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createAuditoria(
    request: CreateAuditorAuditoriaRequest,
  ): Promise<CreateAuditorAuditoriaResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/auditor/auditoria/create`,
        formData,
        options,
      );
      const response =
        handleAxiosResponse<CreateAuditorAuditoriaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async copiaAuditoria(
    request: AuditoriaCopiaRequest,
  ): Promise<AuditoriaCopiaResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/auditor/auditoria/copia`,
        request,
      );
      const response = handleAxiosResponse<AuditoriaCopiaResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async updateAuditoria(
    request: UpdateAuditoriaAuditoriaRequest,
  ): Promise<UpdateAuditorAuditoriaResponse> {
    try {
      const formData = RequestObjectToFormData(request);
      const options = { headers: { "Content-Type": "multipart/form-data" } };
      const result = await axiosInstance({}).post(
        `/auditor/auditoria/update`,
        formData,
        options,
      );
      const response =
        handleAxiosResponse<UpdateAuditorAuditoriaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

  //#region Processo Auditoria
  async createProcessoAuditoria(
    request: CreateAuditorProcessoAuditoriaRequest,
  ): Promise<CreateAuditorProcessoAuditoriaResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/auditor/processoauditoria/create`,
        request,
      );
      const response =
        handleAxiosResponse<CreateAuditorProcessoAuditoriaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllListagemProcessoAuditoria(
    request: GetAllAuditorProcessoAuditoriaRequest,
  ): Promise<GetAllAuditorProcessoAuditoriaResponse> {
    try {
      const result = await axiosInstance({}).post(
        `auditor/processoauditorias/listProcessoAuditorias`,
        request,
      );
      const response =
        handleAxiosResponse<GetAllAuditorProcessoAuditoriaResponse>(result);

      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteAuditoria(
    request: DeleteAuditorAuditoriaRequest,
  ): Promise<DeleteAuditorAuditoriaResponse> {
    try {
      const result = await axiosInstance({}).delete(
        "/auditor/auditoria/delete",
        { data: request },
      );
      const response =
        handleAxiosResponse<DeleteAuditorAuditoriaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async updateProcessoAuditoria(
    request: UpdateAuditoriaProcessoAuditoriaRequest,
  ): Promise<UpdateAuditorProcessoAuditoriaResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/auditor/processoauditoria/update`,
        request,
      );
      const response =
        handleAxiosResponse<UpdateAuditorProcessoAuditoriaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async deleteProcessoAuditoria(
    request: DeleteAuditorProcessoAuditoriaRequest,
  ): Promise<DeleteAuditorProcessoAuditoriaResponse> {
    try {
      const result = await axiosInstance({}).delete(
        "/auditor/processoauditoria/delete",
        { data: request },
      );
      const response =
        handleAxiosResponse<DeleteAuditorProcessoAuditoriaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  async copiaProcessoAuditoria(
    request: ProcessoAuditoriaCopiaRequest,
  ): Promise<ProcessoAuditoriaCopiaResponse> {
    try {
      const result = await axiosInstance({}).post(
        `/auditor/processoauditoria/copia`,
        request,
      );
      const response =
        handleAxiosResponse<ProcessoAuditoriaCopiaResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  //#endregion

  //#region Principal
  async getAllListagemIndicadores(): Promise<GetAllAuditoriaIndicadoresResponse> {
    try {
      const result = await axiosInstance({}).get(
        "/auditor/auditoria/indicadores",
      );
      const rawData = handleAxiosResponse<AuditoriaIndicadores>(result);
      const response: GetAllAuditoriaIndicadoresResponse = {
        indicadores: rawData,
      };
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }
  //#endregion
}
